import { isPageLoadMetricData } from '../../metric/is-page-load-metric-data';
import { isPageSegmentLoadMetricData } from '../../metric/is-page-segment-load-metric-data';
import type {
	BaseMetricDataWithStartAndStop,
	BasePageLoadMetricDataWithStartAndStop,
	PageSegmentLoadMetricDataWithStartAndStop,
	PerformanceEventConfig,
} from '../../types';

export const eventInitial = (
	_config: PerformanceEventConfig,
	data:
		| BaseMetricDataWithStartAndStop
		| PageSegmentLoadMetricDataWithStartAndStop
		| BasePageLoadMetricDataWithStartAndStop,
): {
	'event:initial': boolean;
} | null => {
	if (!isPageLoadMetricData(data) && !isPageSegmentLoadMetricData(data)) {
		return null;
	}
	return {
		'event:initial': data.isInitial,
	};
};
